module.exports = __webpack_public_path__ + "img/brandv-1.4d8a9ae6.jpg";